import React from 'react';

import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';
import PersonalisedMenteeEmailersTableBody from '../PersonalisedMenteeEmailersTableBody';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

export default function PersonalisedMenteeEmailersTable({
  blacklistedLearners,
  blacklistedLearnersMeta,
  isLoading,
  error,
}) {
  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load learners/batches"
        message={
          error?.data?.message || 'Something went wrong! Try again later'
        }
      />
    );
  } else if (blacklistedLearners?.length > 0) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Learner Name</TableCell>
            <TableCell>Learner Email</TableCell>
            <TableCell>Batch Name</TableCell>
            <TableCell>Pause from</TableCell>
            <TableCell>Resume from</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <PersonalisedMenteeEmailersTableBody
          blacklistedLearners={blacklistedLearners}
          blacklistedLearnersMeta={blacklistedLearnersMeta}
        />
      </Table>
    );
  } else {
    return (
      <ErrorLayout
        title="No data available"
        message="Try changing the filter values!"
      />
    );
  }
}
